import axios from 'axios';
import router from '@/router/index';
import { authReady } from '@/utils/authReady.js';

let store = null;

export const setStore = (s) => {
  store = s;
};

export const api = axios.create({
  baseURL: process.env.VUE_APP_API_ROUTE,
  headers: {
    common: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  },
});

export const surveyApi = axios.create({
  baseURL: process.env.VUE_APP_SURVEY_API_ROUTE,
  headers: {
    common: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  },
});

export const setAuthHeader = (token) => {
  api.defaults.headers.common.Authorization = `Bearer ${token}`;
  surveyApi.defaults.headers.common.Authorization = `Bearer ${token}`;
};

export const resetAuthHeader = () => {
  delete api.defaults.headers.common.Authorization;
  delete surveyApi.defaults.headers.common.Authorization;
};

api.interceptors.request.use(
  async (config) => {
    try {
      // Portão do boot: segura a request até o Keycloak terminar de inicializar
      // (init / check-sso). Sem isso, uma chamada disparada no boot sairia com o
      // token velho antes do refresh — 401 → recuperação → logout espúrio no F5.
      // O app renderiza normalmente enquanto isso; quem espera é a chamada, não a
      // tela (o header mostra o botão de login em loading). authReady sempre
      // resolve (tem timeout de segurança), então não há risco de travar.
      await authReady;

      await store.dispatch('updateToken');

      // Aplica o token ATUAL nesta request. O axios já mesclou o header default
      // (token antigo) no config ANTES deste interceptor, então um token
      // recém-renovado pelo updateToken NÃO valeria para esta request — ela
      // sairia com o token expirado (→ 401 → recuperação → loop). Setar direto
      // no config garante que a request use o token fresco.
      const token = store.getters.userToken;

      if (token) {
        // eslint-disable-next-line no-param-reassign
        config.headers.Authorization = `Bearer ${token}`;
      }
    } catch (error) {
      await store.dispatch('sessionExpired');
    }

    return config;
  },
  (error) => {
    router.push({ name: 'Home' });
    Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      const currentRoute = router.currentRoute.name;

      //fallback: stops user from trying to send a ticket with invalid auth
      if (['ManifestationFinish', 'SolicitationFinish'].includes(currentRoute)) {
        store.dispatch('setUnauthorizedError', true);

        return;
      }

      await store.dispatch('sessionExpired');
    }

    return Promise.reject(error);
  },
);
